

import { createRoot } from 'react-dom/client';

import './style.scss';
import Style from './Style';
import ProtectContent from './ProtectContent';

// Email Encoder
document.addEventListener('DOMContentLoaded', () => {
	const emailContentAllEles = document.querySelectorAll('.wp-block-eeb-email-encode');
	emailContentAllEles.forEach(emailContentEle => {
		const attributes = JSON.parse(emailContentEle.dataset.attributes);

		createRoot(emailContentEle).render(<>
			<Style attributes={attributes} clientId={attributes.cId} />
			<div className="eebEmailEncode">
				<ProtectContent attributes={attributes} clientId={attributes.cId} />
			</div>
		</>);

		emailContentEle?.removeAttribute('data-attributes');
	});
});